<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import { formatHours } from '../format.mjs';

  export let invoice;
  export let operatorName;
  export let reportedHours;
  export let ledgerAggregate = null;

  $: askingRate = minorToMoney(invoice.minHourlyRateMinor || 100, invoice.currency);
  $: contributorCount = ledgerAggregate?.contributorCount || 0;
  // Aggregate only, and omitted entirely at zero. Since 2026-08-09 the server
  // publishes the total from the first settled contributor (thresholds dropped
  // after the S02 read), so a null here means nothing has settled yet.
  $: contributedMinor = ledgerAggregate?.contributedMinor ?? null;
</script>

<header class="ledger-header">
  <p class="eyebrow">{invoice.invoiceReference || 'Reported work'}</p>
  <h1>{invoice.recipientLabel}</h1>

  <!-- Title block: the record's facts, before any control. Borrowed from the
       engineering-drawing convention where a bordered grid of labelled cells
       carries authorship and quantity. The fourth cell was left out until U04
       could supply the contributor count without disclosing anyone's amount. -->
  <dl class="title-block">
    <div>
      <dt>Reported by</dt>
      <dd>{operatorName || '—'}</dd>
    </div>
    <div>
      <dt>Hours</dt>
      <dd class="figure">{formatHours(reportedHours)}</dd>
    </div>
    <div>
      <dt>Asking</dt>
      <dd class="figure money">{askingRate}/h</dd>
    </div>
    <div>
      <dt>Contributors</dt>
      <dd class="figure count">{contributorCount}</dd>
    </div>
  </dl>

  {#if contributedMinor !== null && contributorCount > 0}
    <p class="contribution-history">
      {minorToMoney(contributedMinor, invoice.currency)} {invoice.currency} from
      {contributorCount} {contributorCount === 1 ? 'contributor' : 'contributors'}
    </p>
  {/if}

  <p class="model-statement">
    These hours were reported by the person who worked them. Choose what you want
    to pay for, and what an hour of it was worth to you. Nothing here is owed, and
    paying does not close the page — other people can add to the same hours later.
  </p>
  <p class="quiet">All amounts are in {invoice.currency}.</p>
</header>
